import {DomainSubject} from "./domainSubject";
import {logUtil} from "@repo/lib-common";

const interactive='interactive';
const complete='complete';

export class DomReadyStateInteractiveSubject extends DomainSubject<Event>{
    name= "DomReadyStateInteractiveSubject";
    init=()=>{
        if (document.readyState === complete || document.readyState ===interactive) {
            logUtil.consoleLog(`${this.name} document.readyState is already ${document.readyState}`);
            this.trigger();
            return;
        }
        document.addEventListener("readystatechange", (event) => {
            if (document.readyState === interactive) {
                logUtil.consoleLog(`${this.name} document.readyState became ${document.readyState} event:`,event);
                this.trigger();
                }

        });
    }


}

const domReadyStateInteractiveSubject=new DomReadyStateInteractiveSubject();
domReadyStateInteractiveSubject.activate();
export {domReadyStateInteractiveSubject};




